export function wait(ms: number): Promise<void> {
  if (ms === Infinity) {
    // return a promise that never resolves
    return new Promise(() => {}); // eslint-disable-line no-empty-function
  }

  return new Promise((resolve) => setTimeout(resolve, ms));
}
